export default {
  data() {
    return {
      searchSchema: [
        {
          label: '企业名称',
          type: 'input',
          itemName: 'name',
          allowClear: true,
        },
        {
          label: '企业ID',
          type: 'input',
          itemName: 'code',
          allowClear: true,
        },
      ],
      searchForm: {
        name: '',
        code: '',
      },
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableData: [],
      tableColumns: [
        {
          fixed: 'left',
          title: '序号',
          width: 70,
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '企业名称',
          width: 240,
          dataIndex: 'name',
        },
        {
          title: '企业ID',
          width: 240,
          dataIndex: 'code',
        },
        {
          title: 'Geo',
          width: 140,
          dataIndex: 'geo',
        },
        {
          title: '大区/模式',
          width: 180,
          dataIndex: 'region',
        },
        {
          title: '成立年份',
          width: 100,
          dataIndex: 'establishYear',
        },
        {
          title: '合作年限',
          width: 100,
          dataIndex: 'coopTime',
        },
        {
          title: '操作',
          width: 200,
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  methods: {
    // 查询
    handleSearch(data) {
      this.searchForm = { ...this.searchForm, ...data }
      this.pageData.current = 1
      this._getTableData()
    },
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },
  },
}
